// Human-readable labels for all codes across the application

export const STAGE_LABELS = {
  S0: 'Anonimo', S1: 'Lead freddo', S2: 'Lead tiepido', S3: 'Lead caldo',
  S4: 'Prospect attivo', S5: 'Cliente', S6: 'Cliente attivo',
};

export const EVENT_TYPE_LABELS = {
  E1: 'Workshop interattivo', E2: 'Evento networking', E3: 'Webinar / Talk', E4: 'Sessione strategica',
};

export const PRODUCT_STATUS_LABELS = {
  in_sviluppo: 'In sviluppo', beta: 'Beta', in_lancio: 'In lancio',
  active: 'Attivo', attivo: 'Attivo', stagionale: 'Stagionale',
  sospeso: 'Sospeso', ritirato: 'Ritirato',
};

export const DEAL_STAGE_LABELS = {
  new_lead: 'Nuovo Lead', contacted: 'Contattato', discovery_call: 'Discovery Call',
  proposal_sent: 'Proposta Inviata', negotiation: 'Negoziazione',
  closed_won: 'Chiusa Vinta', closed_lost: 'Chiusa Persa',
  lead: 'Lead', proposal: 'Proposta', qualified: 'Qualificato',
};

export const EVENT_STATUS_LABELS = {
  draft: 'Bozza', confirmed: 'Confermato', open: 'Aperto',
  sold_out: 'Tutto esaurito', completed: 'Completato', cancelled: 'Annullato',
};

export const RELATIONSHIP_LABELS = {
  nuovo: 'Nuovo', attivo: 'Attivo', caldo: 'Caldo', dormiente: 'Dormiente',
};

// Helper to get a label with fallback
export function label(map, code) {
  if (!code) return '-';
  return map[code] || code.replace(/_/g, ' ');
}
